<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
  getSysStaticDataByCodeType,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        paymentWayOptions: [], // 成本模式
        vehicleClassOptions: [], // 车辆类型
        cardTypeOptions: [],
        paymentTypeOptions: [],
        chargingStateOptions: [],
        orderStateOptions: [],
        matchTypeOptions: [],
        form: [
          { // ETC卡号
            label: 'ETC卡号',
            value: 'etcCardNo',
            type: 'input',
            placeholder: '请输入ETC卡号',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '消费时间',
            value: 'consumeTime',
            type: 'date',
            default: [],
            placeholder: '请选择消费时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '归属订单',
            value: 'orderId',
            type: 'input',
          },
          {
            label: '扣费状态',
            value: 'chargingState',
            type: 'select',
            default: -1,
          },
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          {
            label: '卡类型',
            value: 'cardType',
            type: 'select',
            default: -1,
          },
          {
            label: '交易地点',
            value: 'tradingSite',
            type: 'input',
          },
          { // 车辆类型
            label: '车辆类型',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '请选择车辆类型',
          },
          {
            label: '付费类型',
            value: 'paymentType',
            type: 'select',
            default: -1,
          },
          {
            label: '账单编号',
            value: 'billNo',
            type: 'input',
          },
          {
            label: '扣费开始',
            value: 'deductDate',
            type: 'date',
            default: [],
            placeholder: '请选择扣费开始时间',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '匹配状态',
            value: 'orderState',
            type: 'select',
            default: -1,
          },
          {
            label: '账单日期',
            value: 'statementDate',
            type: 'date',
            default: [],
            placeholder: '请选择账单日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '成本模式',
            value: 'paymentWay',
            type: 'select',
            default: -1,
          },
          {
            label: '匹配类型',
            value: 'matchType',
            type: 'select',
            default: -1,
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.consumeTime && searchBoxData.consumeTime.length) {
        searchBoxData.beginDate = this.formatDate(searchBoxData.consumeTime[0]);
        searchBoxData.endDate = this.formatDate(searchBoxData.consumeTime[1]);
      }
      delete searchBoxData.consumeTime;
      if (searchBoxData.deductDate && searchBoxData.deductDate.length) {
        searchBoxData.deductBeginDate = this.formatDate(searchBoxData.deductDate[0]);
        searchBoxData.deductEndDate = this.formatDate(searchBoxData.deductDate[1]);
      }
      delete searchBoxData.deductDate;
      if (searchBoxData.statementDate && searchBoxData.statementDate.length) {
        searchBoxData.beginStatementDate = this.formatDate(searchBoxData.statementDate[0]);
        searchBoxData.endStatementDate = this.formatDate(searchBoxData.statementDate[1]);
      }
      delete searchBoxData.statementDate;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'PAYMENT_WAY,VEHICLE_CLASS',
    });
    const resCardType = await getSysStaticDataByCodeType({
      codeType: 'ETC_CARD_TYPE',
    });
    const resPaymentType = await getSysStaticDataByCodeType({
      codeType: 'ETC_SERVICE_PAYMENT_TYPE',
    });
    const resChargingState = await getSysStaticDataByCodeType({
      codeType: 'ETC_CHARGING_STATE',
    });
    const resOrderState = await getSysStaticDataByCodeType({
      codeType: 'ETC_STATE',
    });
    const resMatchType = await getSysStaticDataByCodeType({
      codeType: 'ETC_MATCH_TYPE',
    });
    this.searchBoxData.paymentWayOptions = [ // 成本模式
      { label: '全部', value: -1 },
      ...enumsList[0],
    ];
    this.searchBoxData.vehicleClassOptions = [
      { label: '全部', value: -1 },
      ...enumsList[1],
    ];
    this.searchBoxData.cardTypeOptions = [
      { label: '全部', value: -1 },
      ...resCardType,
    ];
    this.searchBoxData.paymentTypeOptions = [
      { label: '全部', value: -1 },
      ...resPaymentType,
    ];
    this.searchBoxData.chargingStateOptions = [
      { label: '全部', value: -1 },
      ...resChargingState,
    ];
    this.searchBoxData.orderStateOptions = [
      { label: '全部', value: -1 },
      ...resOrderState,
    ];
    this.searchBoxData.matchTypeOptions = [
      { label: '全部', value: -1 },
      ...resMatchType,
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
